<template>
  <hm-content title="">
    <div class="flex flex-start mb10">
      当前供货商: <span class="primary">{{ storeNames }}</span>
      <span class="blue"
        >总计关联商户数{{ storeBasicInfoListBox.length }}家</span
      >
    </div>
    <div class="table-panel flex flex-between">
      <div>
        <el-button type="primary" size="small" @click="addShop"
          >新增门店</el-button
        >
      </div>
      <div>
         <el-input
          clearable
          style="width: 250px"
          v-model.trim="searchCondition.keyCode"
          placeholder="请输入商户/门店编码"
          size="small"
          class="ipt mr10"
        ></el-input>
        <el-input
          clearable
          style="width: 250px"
          v-model.trim="searchCondition.shopName"
          placeholder="请输入门店名称"
          size="small"
          class="ipt mr10"
        ></el-input>
        <el-cascader
          clearable
          style="marginright: 10px"
          ref="cascader"
          v-model="orgCode"
          :props="propsprops"
          :show-all-levels="false"
          size="small"
          placeholder="请选择机构"
        ></el-cascader>
        <!-- <el-select
          size="small"
          clearable
          class="mr10"
          placeholder="选择商户"
          v-model="searchCondition.queryStoreCode"
          style="width: 200px"
          :remote-method="remoteMethod"
          filterable
          remote
        >
          <el-option
            v-for="(item, i) in storeBasicInfoListBoxList"
            :key="item.storeCode"
            :label="item.storeName"
            :value="item.storeCode"
          ></el-option>
        </el-select> -->
        <el-autocomplete
          size="small"
          clearable
          class="mr10"
          style="width: 200px"
          v-model="searchCondition.queryStoreName"
          :fetch-suggestions="querySearchAsync"
          :trigger-on-focus="false"
          placeholder="选择商户"
          popper-class="auto-adjust-el-autocomplete-suggestion"
        >
        </el-autocomplete>
        <!--        <el-select-->
        <!--          size="small"-->
        <!--          clearable-->
        <!--          class="mr10"-->
        <!--          placeholder="选择对应组织架构"-->
        <!--          v-model="searchCondition.departIds"-->
        <!--          style="width: 200px"-->
        <!--          filterable-->
        <!--          multiple-->
        <!--        >-->
        <!--          <el-option-->
        <!--            v-for="(item, i) in shopDepartList"-->
        <!--            :key="i"-->
        <!--            :label="item.depart_name"-->
        <!--            :value="item.depart_id"-->
        <!--          ></el-option>-->
        <!--        </el-select>-->
        <el-button type="primary" size="small" @click="search">查询</el-button>
        <!-- <el-button
          type="success"
          size="small"
          @click="output('queryAllList', '门店列表', 'table')"
          :loading="isOutputing"
          >导出</el-button
        >
      </div> -->
      <el-button
          type="success"
          size="small"
          @click="exportExcel"
          :loading="isOutputing"
          >导出</el-button
        >
      </div>

    </div>
    <div class="table-panel flex flex-between">
      <div>
        <span>已选{{ num }}条</span>
      </div>
      <div class="flex flex-end">
        <div class="delete mr20 pointer open-file">
          <span class="delete-icon hmicon icon-daoru"></span>
          批量导入门店编码
          <input
            type="file"
            @change="importOutletCode"
            accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          />
        </div>

        <div class="delete mr20 pointer open-file">
          <span class="delete-icon hmicon icon-daoru"></span>
          批量导入商户编码
          <input
            type="file"
            @change="importfShopCode"
            accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          />
        </div>

        <div @click="exportStoreActive" class="delete mr20 pointer">
          <span class="delete-icon hmicon icon-daochu"></span>
          导出商户及活动
        </div>
        <div @click="outputExcelShopCode" class="delete mr20 pointer">
          <span class="delete-icon hmicon icon-daochu"></span>
          导出商户模板
        </div>
        <div @click="outputExcelShopCode2" class="delete mr20 pointer">
          <span class="delete-icon hmicon icon-daochu"></span>
          导出门店模板
        </div>
        <span @click="batchSetting" class="pointer">
          <span class="delete-icon hmicon icon-shanchu"></span>
          批量删除
        </span>
      </div>
    </div>
    <div class="table">
      <el-table
        :data="redpackageOutletRelList.records"
        style="width: 100%"
        stripe
        @selection-change="getChecked"
        size="small"
        border
        ref="table"
      >
        <el-table-column type="selection"></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          type="index"
          label="序号"
          width="50"
          :index="(index) => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="商户名"
          prop="storeName"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="商户编码"
          prop="relCode"
        >
          <template slot-scope="scope">
            <el-input v-model="scope.row.relCode" size="mini" placeholder="商户编码" @change="changeMerchantCode(scope.row)"></el-input>
          </template>
        </el-table-column>

        <el-table-column
          header-align="center"
          align="center"
          label="门店编码"
          prop="identifyCode"
        >
          <template slot-scope="scope">
            <el-input v-model="scope.row.identifyCode" size="mini" placeholder="门店编码" @change="changeIdentifyCode(scope.row)"></el-input>
          </template>
        </el-table-column>

        <el-table-column
          header-align="center"
          align="center"
          prop="shopName"
          label="门店名称"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="所在省/市/区"
          prop="citys"
        >
          <template slot-scope="scope">
            <div>
              {{ scope.row.provinceName }}{{ scope.row.cityName
              }}{{ scope.row.districtName }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="shopAddress"
          label="门店地址"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="departName"
          label="对应组织架构"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="createTime"
          label="创建时间"
        ></el-table-column>
        <el-table-column header-align="center" align="center" label="操作">
          <template slot-scope="scope">
            <div class="flex flex-center">
              <el-button size="small" type="text" @click="remove(scope.row)"
                >删除</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="redpackageOutletRelList.total"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="currentPage"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      :title="title"
      width="1600px"
      :before-close="qx"
      :visible.sync="dialogVisible"
    >
      <div class="flex">
        <div class="mr10" style="width: 600px">
          <div class="table-panel flex flex-between">
            <div class="fr" style="width: 100%">
              <el-button
                class="fr"
                type="primary"
                size="small"
                @click="storeSearch"
                >查询</el-button
              >
              <el-input
                clearable
                v-model.trim="storeName"
                placeholder="请输入商户"
                size="small"
                class="ipt mr10 fr"
              >
              </el-input>
            </div>
          </div>
          <div class="table-panel">
            <div class="tables">
              <el-table
                stripe
                ref="roleTable"
                :data="storeBasucList.records"
                style="width: 100%"
                id="table"
                @row-click="tableSelect"
                size="small"
                border
                max-height="500"
                @selection-change="handleSelectionChange"
              >
                <el-table-column
                  type="selection"
                  header-align="center"
                  align="center"
                  width="50"
                >
                </el-table-column>
                <!-- <el-table-column width="36">
                  <template slot-scope="scope">
                    <el-radio
                      :label="scope.row.storeCode"
                      v-model="storeCode"
                      @change.native="getTemplateRow(scope.$index, scope.row)"
                      >&nbsp;</el-radio
                    >
                  </template>
                </el-table-column> -->
                <el-table-column
                  type="index"
                  label="序号"
                  align="center"
                  :index="
                    (index) =>
                      index + (storeCurrentPage - 1) * storePageSize + 1
                  "
                ></el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="storeName"
                  label="商户"
                ></el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="shopCount"
                  width="90"
                  label="门店数"
                ></el-table-column>
              </el-table>
            </div>
            <div class="hm-pagination">
              <el-pagination
                background
                small
                :pager-count="5"
                :total="storeBasucList.total"
                @current-change="storePaging"
                @size-change="storeHandleSizeChange"
                layout="total,sizes,  prev, pager, next, jumper"
                :current-page="storeCurrentPage"
              ></el-pagination>
            </div>
          </div>
        </div>
        <div class="mar10 seach_checked">
          <el-button class="btn" type="primary" size="small" @click="searchShop"
            >查询勾选商户门店</el-button
          >
        </div>
        <div class="mr10 w60" style="width: 800px">
          <div class="table-panel flex flex-between">
            <div class="fl">
              批量设置机构:

              <el-cascader
                clearable
                class="ml10"
                ref="cascader"
                :disabled="this.checkedShopRow.length <= 0"
                v-model="departIds"
                @change="batchDepart"
                placeholder="请选择机构"
                :show-all-levels="false"
                  
                size="small"
                :options="departList"
                :props="{ checkStrictly: true,
                 value: 'id',
    label: 'departName',
    children: 'children',
    checkStrictly: true }"
                :popper-append-to-body="true"
                filterable>
              </el-cascader>


              <!-- <el-cascader
                clearable
                class="ml10"
                ref="cascader"
                :disabled="this.checkedShopRow.length <= 0"
                v-model="departIds"
                @change="batchDepart"
                :props="batchProps"
                :show-all-levels="false"
                size="small"
                placeholder="请选择机构"
              ></el-cascader> -->


            </div>
            <div class="fr">
              <el-input
                clearable
                v-model.trim="shopName"
                placeholder="请输入门店名称"
                size="small"
                class="ipt mr10"
              ></el-input>
              <el-button type="primary" size="small" @click="shopSearch"
                >查询</el-button
              >
              <el-button type="primary" size="small" @click="outputExcel"
                >导出模板</el-button
              >
              <el-button type="primary" size="small" class="open-file">
                导入门店
                <input
                  type="file"
                  @change="importf"
                  accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                />
              </el-button>
            </div>
          </div>
          <div class="table-panel">
            <div class="table">
              <el-table
                stripe
                ref="rightData"
                :data="notRelShopList.records"
                style="width: 100%"
                id="table"
                size="small"
                @row-click="rightTableSelect"
                @selection-change="getShopChecked"
                border
                max-height="500"
              >
                <el-table-column type="selection"></el-table-column>
                <el-table-column
                  type="index"
                  label="序号"
                  :index="
                    (index) => index + (shopCurrentPage - 1) * shopPageSize + 1
                  "
                ></el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="storeName"
                  label="商户"
                ></el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  width="150"
                  prop="shopName"
                  label="门店名称"
                >
                  <template slot-scope="scope">
                    <div class="flex item-center">
                      <span>{{ scope.row.shopName }}</span>
                      <span
                        v-if="scope.row.shopMonthlyStatementFlag"
                        class="monthlyStatement-wrapper"
                        >月结</span
                      >
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  label="所在省/市/区"
                  prop="citys"
                >
                  <template slot-scope="scope">
                    <div>
                      {{ scope.row.provinceName }}{{ scope.row.cityName
                      }}{{ scope.row.districtName }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  label="详细地址"
                  prop="shopAddress"
                >
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  label="组织机构代码"
                  prop="orgCode"
                >
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="roleName"
                  width="170"
                  label="对应组织机构"
                >
                  <template slot-scope="scope">
                    <el-cascader
                      clearable
                      style="marginright: 10px"
                      :ref="`cascader${scope.row.shopId}`"
                      v-model="scope.row.departIds"
                      :props="props"
                      :show-all-levels="false"
                      size="small"
                      placeholder="请选择机构"
                      @change="batchDepart1($event, scope.row)"
                      :disabled="canClick"
                    ></el-cascader>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="hm-pagination">
              <el-pagination
                small
                background
                :total="notRelShopList.total"
                @current-change="shopPaging"
                @size-change="shopHandleSizeChange"
                layout="total,sizes, prev, pager, next, jumper"
                :current-page="shopCurrentPage"
              ></el-pagination>
            </div>
          </div>
        </div>
      </div>
      <div class="btn-wrapper flex flex-center">
        <el-button size="small" type="primary" @click="confirm()"
          >确 定</el-button
        >
        <el-button size="small" @click="qx">取 消</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="errValidImport"
      :close-on-click-modal="false"
      :modal-append-to-body="false"
      :append-to-body="true"
      width="600px"
    >
      <div slot="title">
        <span class="dialog-title">导入失败</span>
        <span class="ml10" style="color: red; font-size: 14px"
          >商品名/门店有误、重复都会导致导入失败</span
        >
      </div>
      <div class="mt10" style="font-size: 14px" v-if="errInputResult.length">
        您有<span style="color: red">{{ errInputResult.length }}</span
        >条数据导入失败！
      </div>
      <div class="mt10" v-if="succInputResult.length">
        您有<span class="success">{{ succInputResult.length }}</span
        >条数据导入成功！
      </div>
      <div class="mt20">
        <el-table :data="errInputResult" border class="small-table">
          <el-table-column
            prop="storeName"
            header-align="center"
            align="center"
            label="商户"
          ></el-table-column>
          <el-table-column
            prop="shopName"
            header-align="center"
            align="center"
            label="门店"
            v-if="!errInputResultshopCode"
          ></el-table-column>
          <el-table-column
            prop="storeSn"
            header-align="center"
            align="center"
            label="商户编码"
            v-else
          ></el-table-column>
        </el-table>
      </div>
    </el-dialog>

    <!-- 门店 -->
    <el-dialog
      :visible.sync="errValidImport1"
      :close-on-click-modal="false"
      :modal-append-to-body="false"
      :append-to-body="true"
      width="600px"
    >
      <div slot="title">
        <span class="dialog-title">导入失败</span>
        <span class="ml10" style="color: red; font-size: 14px"
          >商品名/门店有误、重复都会导致导入失败</span
        >
      </div>
      <div class="mt10" style="font-size: 14px" v-if="errInputResult1.length">
        您有<span style="color: red">{{ errInputResult1.length }}</span
        >条数据导入失败！
      </div>
      <div class="mt10" v-if="succInputResult1.length">
        您有<span class="success">{{ succInputResult1.length }}</span
        >条数据导入成功！
      </div>
      <div class="mt20">
        <el-table :data="errInputResult1" border class="small-table">
          <el-table-column
            prop="supplierName"
            header-align="center"
            align="center"
            label="供货商"
          ></el-table-column>
          <el-table-column
            prop="storeName"
            header-align="center"
            align="center"
            label="商户名"
          ></el-table-column>
          <el-table-column
            prop="shopName"
            header-align="center"
            align="center"
            label="门店"
          ></el-table-column>
          <el-table-column
            prop="identifyCode"
            header-align="center"
            align="center"
            label="门店编码"
          ></el-table-column>
        </el-table>
      </div>
    </el-dialog>


  </hm-content>
</template>

<script>
import { mapGetters } from "vuex";
import XLSX from "xlsx";
import { getCookie, setCookie } from "@/utils/utils";
import { getLoginUser } from "@/utils/auth";
let wb; // 读取完成的数据
let rABS = false; // 是否将文件读取为二进制字符串
export default {
  components: {},
  data() {
    return {
      departIds: "",
      storeNames: "",
      batchProps: {
        lazy: true,
        checkStrictly: true,
        lazyLoad: (node, resolve) => {
          const { level, data } = node;
          if (level === 0) {
            this.$store
              .dispatch("queryOrganizationList", {
                pageNo: 1,
                pageSize: 999,
                loginType: "supplier",
                storeCode: this.$route.query.storeCode,
              })
              .then((res) => {
                res.result.records.forEach((v) => {
                  v.leaf = Boolean(!v.isParent);
                  v.all = {
                    label: v.departName,
                    value: v.id,
                  };
                  v.value = v.all;
                  v.label = v.departName;
                });
                resolve(res.result.records);
              });
          } else {
            this.$store
              .dispatch("queryListOrganizationListByParent", {
                parentId: data.treeStruct,
                loginType: "supplier",
                storeCode: this.$route.query.storeCode,
              })
              .then((res) => {
                if (res.code === "0" && res.result) {
                  res.result.forEach((v) => {
                    v.leaf = Boolean(!v.isParent);
                    v.all = {
                      label: v.departName,
                      value: v.id,
                    };
                    v.value = v.all;
                    v.label = v.departName;
                  });
                  resolve(res.result);
                } else {
                  resolve([]);
                }
              });
          }
        },
      },
      props: {
        lazy: true,
        checkStrictly: true,
        lazyLoad: (node, resolve) => {
          const { level, data } = node;
          // console.log('node',node);
          if (level === 0) {
            this.$store
              .dispatch("queryOrganizationList", {
                pageNo: 1,
                pageSize: 999,
                loginType: "supplier",
                storeCode: this.$route.query.storeCode,
              })
              .then((res) => {
                res.result.records.forEach((v) => {
                  v.leaf = Boolean(!v.isParent);
                  v.value = v.id;
                  v.label = v.departName;
                });
                resolve(res.result.records);
              });
          } else {
            this.$store
              .dispatch("queryListOrganizationListByParent", {
                parentId: data.treeStruct,
                loginType: "supplier",
                storeCode: this.$route.query.storeCode,
              })
              .then((res) => {
                if (res.code === "0" && res.result) {
                  res.result.forEach((v) => {
                    v.leaf = Boolean(!v.isParent);
                    v.value = v.id;
                    v.label = v.departName;
                  });
                  resolve(res.result);
                } else {
                  resolve([]);
                }
              });
          }
        },
      },
      propsprops: {
        lazy: true,
        checkStrictly: true,
        lazyLoad: (node, resolve) => {
          const { level, data } = node;
          if (level === 0) {
            this.$store
              .dispatch("queryOrganizationListTree", {
                pageNo: 1,
                pageSize: 999,
                loginType: "supplier",
                storeCode: this.$route.query.storeCode,
              })
              .then((res) => {
                res.result.records.forEach((v) => {
                  v.leaf = Boolean(!v.isParent);
                  v.value = v.orgCode;
                  v.label = v.departName;
                });
                resolve(res.result.records);
              });
          } else {
            this.$store
              .dispatch("queryListOrganizationListByParentNew", {
                parentId: data.treeStruct,
                loginType: "supplier",
                storeCode: this.$route.query.storeCode,
              })
              .then((res) => {
                if (res.code === "0" && res.result) {
                  res.result.forEach((v) => {
                    v.leaf = Boolean(!v.isParent);
                    v.value = v.orgCode;
                    v.label = v.departName;
                  });
                  resolve(res.result);
                } else {
                  resolve([]);
                }
              });
          }
        },
      },
      orgCode: "",
      departList: [],
      checkedRow: [],
      relStoreCodeList: [],
      checkedShopRow: [],
      searchCondition: {},
      ruleForm: {
        username: "",
      },
      rules: {
        username: [
          {
            required: true,
            min: 2,
            max: 20,
            message: "名称应大于2小于20个字",
            trigger: "blur",
          },
        ],
      },
      num: 0,
      currentPage: 1,
      pageSize: 10,
      storeCurrentPage: 1,
      storePageSize: 10,
      shopCurrentPage: 1,
      shopPageSize: 10,
      title: "",
      dialogVisible: false,
      storeName: "",
      shopName: "",
      storeCode: "",
      storeCodeList: [],
      currentSelectItem: [],
      shopDepartList: [],
      tHeader: ["商户", "门店", "组织机构"],
      tBody: ["storeName", "shopName", "orgCode"],
      tHeaderShopCode: ["商户名称", "商户编码"],
      tHeaderShopCode1: ["商户名","门店名称", "门店编码"],
      tBodyShopCode: ["storeName", "storeSn"],
      tBodyOutletCode: ["storeName","shopName", "identifyCode"],
      errInputResult: [],
      errInputResult1: [],
      errValidImport: false,
      errValidImport1: false,
      importData: false,
      storeBasicInfoListBoxList: [],
      errInputResultshopCode: false,
      succInputResult: [],
      succInputResult1: [],
      canClick: false,
      ActStoreCode: "",
      isOutputing: false,
    };
  },
  computed: mapGetters([
    "redpackageOutletRelList",
    "storeBasicInfoListBox",
    "storeBasucList",
    "notRelShopList",
  ]),
  watch: {},
  created() {
    this.getDepartList();
  },
  mounted() {
    if (this.$route.query.ActStoreCode) {
      this.ActStoreCode = this.$route.query.ActStoreCode;
    }
    this.storeNames = localStorage.getItem("storeName");
    this.getParamsCookie();
    this.queryList();
    this.queryShopDepartList();
    this.$store.dispatch("queryStoreBasicInfoListBox", {
      supplierCode: this.$route.query.storeCode,
    });
  },
  methods: {
    // 获取departList
    async getDepartList() {
      const { result } = await this.$store.dispatch("queryDepartList", {
        storeCode: this.$route.query.storeCode,
      });
      result.forEach((entry) => {
        entry.value = entry.id;
        entry.label = entry.departName;
        if (entry.children.length > 0) {
          entry.children.forEach((v) => {
            v.value = v.id;
            v.label = v.departName;
            if (v.children.length > 0) {
              v.children.forEach((vv) => {
                vv.value = vv.id;
                vv.label = vv.departName;
                if (vv.children.length > 0) {
                  vv.children.forEach((vvv) => {
                    vvv.value = vvv.id;
                    vvv.label = vvv.departName;
                  });
                } else {
                  delete vv.children;
                }
              });
            } else {
              delete v.children;
            }
          });
        } else {
          delete entry.children;
        }
      });
      this.departList = result;
    },

    // 导出
    exportExcel() {
      let params = {
        supplierCode: this.$route.query.storeCode,
        orgCode: this.orgCode[this.orgCode.length - 1],
        supplierName: this.storeNames,
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));

      searchCondition.createTimeStart =
        this.searchCondition.date && this.searchCondition.date.length > 0
          ? this.searchCondition.date[0]
          : "";
      searchCondition.createTimeEnd =
        this.searchCondition.date && this.searchCondition.date.length > 0
          ? this.searchCondition.date[0]
          : "";
      searchCondition.queryStoreCode =
        this.searchCondition.queryStoreCode || this.ActStoreCode;
      Object.assign(params, searchCondition);

      const result = this.$store.dispatch(
        "exportRedpackageOutletRelList",
        params
      );
      console.log(result);
      if (result) {
        setTimeout(() => {
          this.$message({
            message: "已加入导出队列正在生成报表，请在导出列队中查看！",
            type: "success",
          });
          this.hidden = false;
        }, 0);
      }
    },

    // 门店
    changeIdentifyCode(row) {
      let that = this;
      this.$confirm("确定更改门店编码吗？", "提示", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        type: "warning",
      })
        .then(() => {
          console.log("ok");
          const items = {
            identifyCode: row.identifyCode,
            shopName: row.shopName,
            storeName: row.storeName,
            supplierCode: this.$route.query.storeCode,
            supplierName: this.storeNames,
          };
          const arr = [];
          arr.push(items);
          that.$store
            .dispatch("importRedpackageOutletRelByIdentifyCode", arr)
            .then((res) => {
              const { code, result } = res;
              if (code === "0") {
                if (result && result.failList.length > 0) {
                  that.errInputResultshopCode = true;
                  that.errInputResult1 = result.failList;
                  that.errValidImport1 = true;
                }
                if (result && result.successList.length > 0) {
                  that.succInputResult1 = result.successList;
                  that.currentPage = 1;
                  that.queryList();
                }
              }
            });
        })
        .catch(() => {
          that.queryList();
        });
    },
    changeMerchantCode(row) {
      let that = this;
      this.$confirm("确定更改商户编码吗？", "提示", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        type: "warning",
      })
        .then(() => {
          console.log("ok");
          const items = {
            storeCode: row.storeCode,
            storeName: row.storeName,
            storeSn: row.relCode || "",
            supplierCode: this.$route.query.storeCode,
            supplierName: this.storeNames,
          };
          const arr = [];
          arr.push(items);
          that.$store.dispatch("importShopCode", arr).then((res) => {
            const { code, result } = res;
            if (code === "0") {
              if (result && result.failList.length > 0) {
                that.errInputResultshopCode = true;
                that.errInputResult = result.failList;
                that.errValidImport = true;
              }
              if (result && result.successList.length > 0) {
                that.succInputResult = result.successList;
                that.currentPage = 1;
                that.queryList();
              }
            }
          });
          // if (row.relCode === null || row.relCode === "") {
          //   this.$message.error("该商户编码为空,不支持更改");
          // }
        })
        .catch(() => {
          that.queryList();
        });
    },

    remoteMethod(query) {
      if (query !== "") {
        this.storeBasicInfoListBoxList = this.storeBasicInfoListBox.filter(
          (v) => v.storeName.indexOf(query) > -1
        );
      } else {
        this.storeBasicInfoListBoxList = [];
      }
    },
    querySearchAsync(query, cb) {
      //var restaurants = this.restaurants;
      var results = query
        ? this.storeBasicInfoListBox.filter(
            (v) => v.storeName.indexOf(query) > -1
          )
        : this.storeBasicInfoListBox;
      // 调用 callback 返回建议列表的数据
      if (results !== query) {
        results.forEach((v) => {
          v.label = v.storeCode;
          v.value = v.storeName;
        });
      }
      cb(results);
    },
    //左边表格表格选中
    tableSelect(row, column, event) {
      this.$refs.roleTable.toggleRowSelection(row);
    },
    rightTableSelect(row, column, event) {
      if (column.label != "对应组织机构") {
        this.$refs.rightData.toggleRowSelection(row);
      }
    },
    //导出商户编码模板
    async outputExcelShopCode() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        exportJsonToExcel(this.tHeaderShopCode, [[]], "商户编码模板");
      });
    },
    async outputExcelShopCode2() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        exportJsonToExcel(this.tHeaderShopCode1, [[]], "门户编码模板");
      });
    },
    //导入商户编码模板
    importfShopCode(e) {
      const obj = e.target;
      const that = this;
      this.inputData = [];
      if (!obj.files) {
        return;
      }
      let f = obj.files[0];
      let reader = new FileReader();
      reader.onload = function(e) {
        let data = e.target.result;
        if (rABS) {
          wb = XLSX.read(btoa(this.fixdata(data)), {
            // 手动转化
            type: "base64",
          });
        } else {
          wb = XLSX.read(data, {
            type: "binary",
          });
        }
        let result = null;
        wb.SheetNames.forEach((sheetName) => {
          let roa = XLSX.utils.sheet_to_json(wb.Sheets[sheetName], {
            header: 1,
          });
          if (roa.length) {
            result = roa.slice(1);
          }
        });
        // console.log("result:",result);
        let formatResultDataList = [];
        result.map((v, i) => {
          formatResultDataList.push({});
          that.tBodyShopCode.map((o, index) => {
            formatResultDataList[i][that.tBodyShopCode[index]] = v[index]
              ? (v[index] + "").replace(/\s*/g, "")
              : "";
          });
          formatResultDataList[i]["supplierCode"] = that.$route.query.storeCode;
          formatResultDataList[i]["supplierName"] = that.storeNames;
        });
        console.log("formatResultDataList:", formatResultDataList);
        that.$store
          .dispatch("importShopCode", formatResultDataList)
          .then((res) => {
            const { code, result } = res;
            if (code === "0") {
              if (result && result.failList.length > 0) {
                that.errInputResultshopCode = true;
                that.errInputResult = result.failList;
                that.errValidImport = true;
              }else {
                 that.errInputResult = []
              }
              if (result && result.successList.length > 0) {
                that.succInputResult = result.successList;
                that.currentPage = 1;
                that.queryList();
              }else {
                that.succInputResult = []
              }
               if(result && result.failList.length == 0 && result.successList.length > 0) {
                 that.$message({
                  message: "操作成功",
                  type: "success",
                });
              }
            }
          });
      };
      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }
      obj.value = "";
    },

    // 批量导入门店模板
    importOutletCode(e) {
      const obj = e.target;
      const that = this;
      this.inputData = [];
      if (!obj.files) {
        return;
      }
      let f = obj.files[0];
      let reader = new FileReader();
      reader.onload = function(e) {
        let data = e.target.result;
        if (rABS) {
          wb = XLSX.read(btoa(this.fixdata(data)), {
            // 手动转化
            type: "base64",
          });
        } else {
          wb = XLSX.read(data, {
            type: "binary",
          });
        }
        let result = null;
        wb.SheetNames.forEach((sheetName) => {
          let roa = XLSX.utils.sheet_to_json(wb.Sheets[sheetName], {
            header: 1,
          });
          if (roa.length) {
            result = roa.slice(1);
          }
        });
        console.log("result3333:", result);
        let formatResultDataList = [];
        result.map((v, i) => {
          formatResultDataList.push({});
          that.tBodyOutletCode.map((o, index) => {
            formatResultDataList[i][that.tBodyOutletCode[index]] = v[index]
              ? (v[index] + "").replace(/\s*/g, "")
              : "";
          });
          formatResultDataList[i]["supplierCode"] = that.$route.query.storeCode;
          formatResultDataList[i]["supplierName"] = that.storeNames;
        });
        console.log("formatResultDataList:", formatResultDataList);
        that.$store
          .dispatch(
            "importRedpackageOutletRelByIdentifyCode",
            formatResultDataList
          )
          .then((res) => {
            const { code, result } = res;
            if (code === "0") {
              if (result && result.failList.length > 0) {
                that.errInputResultshopCode1 = true;
                that.errInputResult1 = result.failList;
                that.errValidImport1 = true;
              }else {
                 that.errInputResult1 = []
              }
              if (result && result.successList.length > 0) {
                that.succInputResult1 = result.successList;
                that.currentPage = 1;
                that.queryList();
              }else {
                that.succInputResult1 = []
              }
              if(result && result.failList.length == 0 && result.successList.length > 0) {
                 that.$message({
                  message: "操作成功",
                  type: "success",
                });
              }
            }
          });
      };
      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }
      obj.value = "";
    },

    //导出模板
    async outputExcel() {
      const { result } = await this.$store.dispatch("queryDict", {
        textCode: "download-supplier-shopList-imporShop",
      });
      let header = JSON.parse(result.textContentZhCn).data;
      console.log(
        "动态表头",
        this.tHeader,
        "动态配置的数据",
        JSON.parse(result.textContentZhCn).data
      );
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        exportJsonToExcel(header, [[]], "模板");
      });
    },
    //导出商户及活动
    exportStoreActive() {
      this.$store.dispatch("exportStoreActive", {
        supplierCode: this.$route.query.storeCode,
      });
      setTimeout(() => {
        this.$message({
          message: "已加入导出队列正在生成报表，请在导出列队中查看！",
          type: "success",
        });
        this.hidden = false;
      }, 0);
    },
    //导入门店
    importf(e) {
      const obj = e.target;
      const that = this;
      this.inputData = [];
      if (!obj.files) {
        return;
      }
      let f = obj.files[0];
      let reader = new FileReader();
      reader.onload = function(e) {
        let data = e.target.result;
        if (rABS) {
          wb = XLSX.read(btoa(this.fixdata(data)), {
            // 手动转化
            type: "base64",
          });
        } else {
          wb = XLSX.read(data, {
            type: "binary",
          });
        }
        let result = null;
        wb.SheetNames.forEach((sheetName) => {
          let roa = XLSX.utils.sheet_to_json(wb.Sheets[sheetName], {
            header: 1,
          });
          if (roa.length) {
            result = roa.slice(1);
          }
        });

        let formatResult = {};
        let formatResultDataList = [];
        formatResult.supplierCode = that.$route.query.storeCode;

        result.map((v, i) => {
          formatResultDataList.push({});
          that.tBody.map((o, index) => {
            formatResultDataList[i][that.tBody[index]] = v[index]
              ? (v[index] + "").replace(/\s*/g, "")
              : "";
          });
        });
        formatResult.notRelShopModelList = formatResultDataList;
        // console.log('formatResult',formatResult);
        that.$store.dispatch("importNotRelShop", formatResult).then((res) => {
          const { code, result } = res;
          // console.log("result: ", result);
          if (code === "0") {
            if (result && result.errList.length > 0) {
              that.errInputResultshopCode = false;
              that.errInputResult1 = result.errList;
              that.errValidImport1 = true;
            }
            if (result && result.succList.length > 0) {
              that.importData = true;
              that.notRelShopList.records = JSON.parse(
                JSON.stringify(result.succList)
              );
              setTimeout(() => {
                that.notRelShopList.records.forEach((v) => {
                  v.departIds = [v.departId];
                  that.$refs.rightData.toggleRowSelection(v);
                });
                console.log(
                  "that.notRelShopList.records",
                  that.notRelShopList.records
                );
              }, 0);
            }
          }
        });
      };
      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }
      obj.value = "";
    },
    batchDepart1(val, row) {
      console.log("val", val);
      if (!!val && val.length > 0) {
        let nodesInfo = this.$refs["cascader" + row.shopId].getCheckedNodes();
        row.orgCode = nodesInfo[0].data.orgCode;
      } else {
        row.orgCode = "";
      }
    },
    // findLabelsByValues(options, values) {
    //   let selectedLabels = [];
    //   let tempOptions = options;
    //   for (let i = 0; i < values.length; i++) {
    //     let found = false;
    //     for (let j = 0; j < tempOptions.length; j++) {
    //       if (tempOptions[j].value == values[i]) {
    //         selectedLabels.push(tempOptions[j].label);
    //         tempOptions = tempOptions[j].children || [];
    //         found = true;
    //         break;
    //       }
    //     }
    //     if (!found) break; // 如果没有找到匹配项，则退出循环
    //   }
    //   return selectedLabels;
    // },
    findLabelsByValues(options, values) {
      let selectedLabels = [];
      // 递归函数用于查找值对应的标签
      function findLabelRecursive(currentOptions, currentValueIndex) {
        if (currentValueIndex >= values.length) {
          return;
        }
        for (let i = 0; i < currentOptions.length; i++) {
          if (currentOptions[i].id === values[currentValueIndex]) {
            selectedLabels.push(currentOptions[i].departName);
            // 如果有子节点，继续递归查找下一个值
            if (
              currentOptions[i].children &&
              currentOptions[i].children.length > 0
            ) {
              findLabelRecursive(
                currentOptions[i].children,
                currentValueIndex + 1
              );
            }
            return;
          }
        }
      }
      findLabelRecursive(options, 0);
      return selectedLabels;
    },
    batchDepart(val) {
      // 获取选中的label，需要遍历departList找到对应的label
      const labels = this.findLabelsByValues(this.departList, val);
      console.log("Selected labels:", labels);
      if (val.length > 0) {
        let arrs = [];
        val.forEach((v, index) => {
          arrs.push({ label: labels[index], value: v });
        });

        val = arrs;
        if (this.checkedShopRow <= 0) {
          this.$message({
            message: "请选择",
            type: "warning",
          });
        } else {
          this.checkedShopRow.forEach((v, i) => {
            v.departIds = [val[val.length - 1].value];
            setTimeout(() => {
              this.$refs["cascader" + v.shopId].presentText =
                val[val.length - 1].label;
            }, 0);
          });
          this.checkedShopRow = [...this.checkedShopRow];
          // this.notRelShopList.records.forEach((v, i) => {
          //   if (
          //     this.checkedShopRow.findIndex(o => o.shopId == v.shopId) === 0
          //   ) {
          //     this.$refs["cascader" + i].presentText =
          //       val[val.length - 1].label;
          //   }
          // });
        }
      } else {
        this.checkedShopRow.forEach((v, i) => {
          this.$refs["cascader" + v.shopId].presentText = "";
          v.departIds = [];
        });
      }
    },
    async queryShopDepartList() {
      const { result } = await this.$store.dispatch("queryShopDepartList", {
        storeCode: this.$route.query.storeCode,
      });
      this.shopDepartList = result;
    },
    resetRuleForm() {
      this.$refs.ruleForm.resetFields();
    },

    getChecked(selection) {
      // console.log("selection::", selection);
      this.checkedRow = selection.map((v) => v.redpackageOutletId);
      this.relStoreCodeList = selection.map((v) => v.relStoreCode);
      this.num = selection.length;
    },
    getShopChecked(selection) {
      this.checkedShopRow = selection;
      // console.log("selection::::", this.checkedShopRow)
    },
    queryList() {
      let params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage,
        storeCode: this.$route.query.storeCode,
        orgCode: this.orgCode[this.orgCode.length - 1],
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));

      searchCondition.createTimeStart =
        this.searchCondition.date && this.searchCondition.date.length > 0
          ? this.searchCondition.date[0]
          : "";
      searchCondition.createTimeEnd =
        this.searchCondition.date && this.searchCondition.date.length > 0
          ? this.searchCondition.date[0]
          : "";
      searchCondition.queryStoreCode =
        this.searchCondition.queryStoreCode || this.ActStoreCode;
      Object.assign(params, searchCondition);
      // console.log("searchCondition:::", searchCondition);
      // console.log("this.orgCodes:::", this.orgCode[1]);
      this.setParamsCookie();

      return this.$store.dispatch("queryRedpackageOutletRelList", params);
    },
    queryAllList() {
      let params = {
        pageSize: 999999,
        pageNo: this.currentPage,
        storeCode: this.$route.query.storeCode,
        orgCode: this.orgCode[this.orgCode.length - 1],
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));

      searchCondition.createTimeStart =
        this.searchCondition.date && this.searchCondition.date.length > 0
          ? this.searchCondition.date[0]
          : "";
      searchCondition.createTimeEnd =
        this.searchCondition.date && this.searchCondition.date.length > 0
          ? this.searchCondition.date[0]
          : "";
      searchCondition.queryStoreCode =
        this.searchCondition.queryStoreCode || this.ActStoreCode;
      Object.assign(params, searchCondition);
      // console.log("searchCondition:::", searchCondition);
      // console.log("this.orgCodes:::", this.orgCode[1]);
      this.setParamsCookie();

      return this.$store.dispatch("queryRedpackageOutletRelList", params);
    },
    setParamsCookie() {
      setCookie({
        key: "redpackageShoptListParamsNew" + this.$route.query.storeCode,
        type: "session",
        data: Object.assign({}, this.searchCondition, {
          pageSize: this.pageSize,
          currentPage: this.currentPage,
        }),
      });
    },
    getParamsCookie() {
      const prams = getCookie({
        key: "redpackageShoptListParamsNew" + this.$route.query.storeCode,
        type: "session",
      });
      if (prams) {
        let search = {};
        for (let key in prams) {
          if (key !== "pageSize" && key !== "currentPage") {
            search[key] = prams[key];
          }
        }
        this.searchCondition = search;
        this.pageSize = prams.pageSize;
        this.currentPage = prams.currentPage;
      }
    },
    queryStoreList() {
      let params = {
        pageSize: this.storePageSize,
        pageNo: this.storeCurrentPage,
        storeName: this.storeName,
        queryRewardFlag: "exclude",
        queryRewardNumStat: "exclude",
        queryShopStat: "include",
        queryTemplateStat: "exclude",
        queryRiskeStat: "exclude",
      };
      this.$store.dispatch("queryStoreBasicList", params);
    },
    queryShopList() {
      let params = {
        pageSize: this.shopPageSize,
        pageNo: this.shopCurrentPage,
        shopName: this.shopName,
        storeCodeList: this.storeCodeList,
        supplierCode: this.$route.query.storeCode,
      };
      this.$store.dispatch("queryNotRelShopList", params);
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    searchShop() {
      this.canClick = false;
      if (this.storeCodeList.length) {
        this.shopCurrentPage = 1;
        this.importData = false;
        this.queryShopList();
      } else {
        this.$message({
          message: "请选择商户",
          type: "warning",
        });
      }
    },
    storeSearch() {
      this.storeCurrentPage = 1;
      this.queryStoreList();
    },
    storePaging(page) {
      this.storeCurrentPage = page;
      this.queryStoreList();
    },
    storeHandleSizeChange(size) {
      this.storeCurrentPage = 1;
      this.storePageSize = size;
      this.queryStoreList();
    },
    shopSearch() {
      this.shopCurrentPage = 1;
      this.queryShopList();
    },
    shopPaging(page) {
      this.shopCurrentPage = page;
      this.queryShopList();
    },
    shopHandleSizeChange(size) {
      this.shopCurrentPage = 1;
      this.shopPageSize = size;
      this.queryShopList();
    },

    remove(row) {
      this.$confirm(" 删除本行数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let params = {
          redpackageOutletIds: [row.redpackageOutletId],
          relStoreCodeList: [row.relStoreCode],
        };
        this.$store.dispatch("delRedpackageOutletRel", params).then((res) => {
          if (res.code === "0") {
            this.$message({
              message: " 操作成功",
              type: "success",
            });
            this.queryList();
          }
        });
      });
    },
    batchSetting() {
      if (this.checkedRow.length) {
        let say = "删除已选" + this.checkedRow.length + "条数据";
        this.$confirm(say, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          let params = {
            redpackageOutletIds: this.checkedRow,
            relStoreCodeList: this.relStoreCodeList,
          };
          this.$store.dispatch("delRedpackageOutletRel", params).then((res) => {
            if (res.code === "0") {
              this.$message({
                message: " 操作成功",
                type: "success",
              });
              this.queryList();
            }
          });
        });
      } else {
        this.$message({
          message: "请选择",
          type: "warning",
        });
      }
    },
    // getTemplateRow(index, row) {
    //   this.shopCurrentPage = 1;
    //   this.queryShopList();
    // },
    handleSelectionChange(row) {
      this.storeCodeList = row.map((v) => v.storeCode);
    },

    addShop() {
      this.title = "新增门店";
      this.dialogVisible = true;
      this.notRelShopList.records = [];
      this.notRelShopList.total = 0;
      this.shopCurrentPage = 1;
      this.shopPageSize = 10;
      this.queryStoreList();
    },
    confirm() {
      // console.log("this.checkedShopRow:", this.checkedShopRow)
      if (this.checkedShopRow <= 0) {
        this.$message({
          message: "请选择",
          type: "warning",
        });
      } else {
        let flag = false;
        let shopMonthlyStatementFlag = false;
        let hasShopMonthlyStatementFlag = false;
        this.notRelShopList.records.forEach((v) => {
          if (v.shopMonthlyStatementFlag) {
            hasShopMonthlyStatementFlag = true;
          }
        });

        this.checkedShopRow.forEach((v) => {
          if (v.departIds && v.departIds.length > 0) {
            v.departId = v.departIds[v.departIds.length - 1];
          } else {
            flag = true;
          }
        });
        // console.log("hasShopMonthlyStatementFlag:::", hasShopMonthlyStatementFlag)
        if (hasShopMonthlyStatementFlag) {
          this.checkedShopRow.forEach((v) => {
            if (v.shopMonthlyStatementFlag) {
              shopMonthlyStatementFlag = true;
            }
          });
        }
        // console.log("shopMonthlyStatementFlag:::", shopMonthlyStatementFlag)
        if (flag) {
          this.$message({
            message: "请选择对应组织架构",
            type: "warning",
          });
        } else if (!shopMonthlyStatementFlag && hasShopMonthlyStatementFlag) {
          this.$confirm("是否绑定月结门店?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              //选中月结，并插入数据
              this.notRelShopList.records.forEach((v) => {
                if (v.shopMonthlyStatementFlag) {
                  this.checkedShopRow.push(v);
                  this.$refs.rightData.toggleRowSelection(v);
                }
              });
            })
            .catch(() => {
              //不绑月结
              this.bind();
            });
        } else {
          this.bind();
        }
      }
    },
    bind() {
      this.canClick = true;
      // console.log(this.checkedShopRow)
      let params = {
        storeCode: this.$route.query.storeCode,
        shopIdAndDepartIds: this.checkedShopRow,
      };

      this.$store.dispatch("saveRedpackageOutletRel", params).then((res) => {
        this.canClick = false;
        if (res.code === "0") {
          this.$message({
            message: " 操作成功",
            type: "success",
          });

          if (this.importData) {
            this.notRelShopList.records = [];
          } else {
            this.queryShopList();
          }
          // this.rest();
          // this.storeCode = "";
          // this.$store.commit("queryStoreBasuc");
          // this.$store.commit("queryNotRelShop");

          this.checkedShopRow = [];
          this.queryList();
        }
      });
    },
    qx() {
      this.dialogVisible = false;
      this.rest();
    },
    rest() {
      setTimeout(() => {
        this.departIds = "";
        this.storeCode = "";
        this.storeName = "";
        this.shopName = "";
        this.storeBasucList.records = [];
        this.storeBasucList.total = 0;
        this.notRelShopList.records = [];
        this.notRelShopList.total = 0;
      }, 0);
    },
    // 导出excel
    output(funcName, title, table) {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        this.isOutputing = true;
        const func = this[funcName];
        func()
          .then((res) => {
            // console.log("output--res:",res);
            const list = res.result.records;
            list.forEach((v) => {
              v.citys = v.provinceName + v.cityName + v.districtName;
            });

            const tHeader = this.$refs[table].columns
              .map((o) => o.label !== "序号" && o.label !== "操作" && o.label)
              .filter((o) => o);
            let filterVal = [];
            if (list.length > 0) {
              filterVal = this.$refs[table].$children
                .map((o) => o._props.prop)
                .filter((o) => o);
            }

            const data = this.formatJson(filterVal, list);
            exportJsonToExcel(
              tHeader,
              data,
              title + new Date().toLocaleString()
            );
            this.isOutputing = false;
            this.queryList();
          })
          .catch(() => {
            this.isOutputing = false;
          });
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
  },
};
</script>
<style lang="scss">
.tables {
  .el-radio__label {
    display: none;
  }
}
</style>
<style lang="scss" scoped>
.w70 {
  width: 55%;
}
.w30 {
  width: 45%;
}
.w28 {
  width: 28%;
}
.w60 {
  width: 60%;
}
// .flex {
//   display: flex;
//   .w15 {
//     flex: 1;
//   }
//   .w85 {
//     flex: 3;
//   }
// }
.seach_checked {
  width: 160px;
  height: 100%;
  padding-top: 20%;
  padding-left: 15px;
  margin-right: 25px;
  box-sizing: border-box;
}
.fl {
  float: left;
}
.fr {
  float: right;
}
.monthlyStatement-wrapper {
  padding: 1px 2px;
  border: 1px solid #e60e6d;
  white-space: nowrap;
  margin-left: 5px;
}
</style>
